import { Workbook } from "exceljs";

export interface CoverSheetData {
	programName: string;
	exportedAt: Date;
	startDate?: string;
	endDate?: string;
	orgUnitFilter?: string;
	researcherFilter?: string;
}

export const addCoverSheet = (
	workbook: Workbook,
	data: CoverSheetData,
): void => {
	const sheet = workbook.addWorksheet("Cover");
	sheet.columns = [
		{ key: "label", width: 26 },
		{ key: "value", width: 60 },
	];

	const rows: Array<[string, string]> = [
		["Program", data.programName],
		["Exported at", data.exportedAt.toISOString()],
		["Start date", data.startDate ?? "All time"],
		["End date", data.endDate ?? "All time"],
		["Org unit filter", data.orgUnitFilter ?? "All"],
		["Researcher filter", data.researcherFilter ?? "All"],
	];

	for (const [label, value] of rows) {
		const row = sheet.addRow({ label, value });
		row.getCell(1).font = { bold: true };
	}
};
